import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'Index',
    meta: { title: '网站首页' },
    component: () => import(/* webpackChunkName: "Index" */ '../views/index/index'),
    redirect: '/index/home',
    children: [
      { path: 'home', name: 'Home', component: () => import(/* webpackChunkName: "Index" */ '../views/home/index'), meta: { title: '网站首页' } },
      { path: 'about', name: 'About', component: () => import(/* webpackChunkName: "Index" */ '../views/about/index'), meta: { title: '关于我们' } },
      { path: 'product', name: 'Product', component: () => import(/* webpackChunkName: "Index" */ '../views/product/index'), meta: { title: '产品展示' } },
      {
        path: 'article',
        name: 'Article',
        component: () => import(/* webpackChunkName: "Index" */ '../views/article/index'),
        meta: { title: '技术文章' },
        redirect: '/index/article/article-list',
        children: [
          { path: 'article-list', name: 'ArticleList', component: () => import(/* webpackChunkName: "Index" */ '../views/article/article-list/index'), meta: { title: '文章列表' } },
          { path: 'article-detail', name: 'ArticleDetail', component: () => import(/* webpackChunkName: "Index" */ '../views/article/article-detail/index'), meta: { title: '文章详情' } }
        ]
      },
      { path: 'case', name: 'Case', component: () => import(/* webpackChunkName: "Index" */ '../views/case/index'), meta: { title: '成功案列' } },
      { path: 'contact', name: 'Contact', component: () => import(/* webpackChunkName: "Index" */ '../views/contact/index'), meta: { title: '联系我们' } }
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router
